import React, { useState, useEffect } from 'react';
import { Button } from '../globalStyles';
import { Modal, ModalOverlay, ModalContent } from './styles';

const InactivityModal = ({ isOpen, onContinue, onReset, countdownDuration = 30 }) => {
  const [countdown, setCountdown] = useState(countdownDuration);

  useEffect(() => {
    if (!isOpen) {
      setCountdown(countdownDuration);
      return;
    }

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          onReset();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isOpen, countdownDuration, onReset]);

  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <Modal>
        <ModalContent>
          <h2>Are you still there?</h2>
          <p>You haven't interacted with the screen for a while.</p>
          <p>Would you like to continue or start over?</p>

          <div className="button-container">
            <Button className="btn primary" onClick={onContinue}>
              Yes, continue
            </Button>
            <Button className="btn secondary" onClick={onReset}>
              Start new quiz ({countdown}s)
            </Button>
          </div>
        </ModalContent>
      </Modal>
    </ModalOverlay>
  );
};

export default InactivityModal; 